type Props = {
  q: string;
  setQ: (s: string) => void;
  tag: string | null;
  setTag: (t: string | null) => void;
  tags: string[];
  filtered: number;
  total: number;
};

export function FilterBar({ q, setQ, tag, setTag, tags, filtered, total }: Props) {
  return (
    <div className="filterbar">
      <div className="search">
        <span className="search__slash">/</span>
        <input
          className="search__in"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="search title, tag, week…"
          aria-label="search shaders"
        />
        <span className="search__cnt">
          {filtered}/{total}
        </span>
      </div>
      <div className="tags">
        <button className={`pill ${tag === null ? "on" : ""}`} onClick={() => setTag(null)}>
          all
        </button>
        {tags.map((t) => (
          <button
            key={t}
            className={`pill ${tag === t ? "on" : ""}`}
            onClick={() => setTag(tag === t ? null : t)}
          >
            {t}
          </button>
        ))}
      </div>
    </div>
  );
}
